import { HD_URL, HD_URL_L } from '../constants';

export const breadcrumbLinks = (storeId, storeName, city, state, postalCode) => {
  const cleanValue = (value) => value?.trim()
    .replace(/[^0-9a-zA-Z()%-]+|%20/g, '-')
    .replace(/[()]/g, '')
    .replace(/^0+/g, '') || '';

  const cleanedStoreId = cleanValue(storeId) || '';
  const cleanedName = cleanValue(storeName) || '';
  const cleanedCity = cleanValue(city) || '';
  const cleanedState = cleanValue(state) || '';
  const cleanedPostalCode = cleanValue(postalCode) || '';

  return {
    url: HD_URL,
    urlL: HD_URL_L,
    urlState: HD_URL_L + cleanedState,
    storeUrl: `${HD_URL_L}${cleanedName}/${cleanedState}/${cleanedCity}/${cleanedPostalCode}/${cleanedStoreId}`
  };
};

const getDataForBreadcrumbs = (data) => {
  const { storeId, name } = data?.storeData?.storeSearch?.stores?.[0] || {};
  const {
    city,
    state,
    postalCode,
  } = data?.storeData?.storeSearch?.stores?.[0]?.address || {};
  const {
    url,
    urlL,
    urlState,
    storeUrl
  } = breadcrumbLinks(storeId, name, city, state, postalCode);
  return {
    name,
    state,
    storeUrl,
    url,
    urlL,
    urlState
  };
};

export const getStructuredBreadcrumbs = (data) => {
  const {
    name,
    state,
    storeUrl,
    url,
    urlL,
    urlState
  } = getDataForBreadcrumbs(data?.props);
  const itemListElement = [
    {
      '@type': 'ListItem',
      position: 1,
      item: {
        name: 'Home',
        '@id': url
      }
    },
    {
      '@type': 'ListItem',
      position: 2,
      item: {
        name: 'Store Locator',
        '@id': urlL + 'store-locator'
      }
    },
    {
      '@type': 'ListItem',
      position: 3,
      item: {
        name: 'Store Directory',
        '@id': `${urlL}storeDirectory`
      }
    },
    {
      '@type': 'ListItem',
      position: 4,
      item: {
        name: `${state}`,
        '@id': urlState
      }
    },
    {
      '@type': 'ListItem',
      position: 5,
      item: {
        name: `${name}`,
        '@id': storeUrl
      }
    }
  ];

  if (data?.departmentName && data?.departmentID) {
    itemListElement.push({
      '@type': 'ListItem',
      position: 6,
      item: {
        name: data?.departmentName,
        '@id': `${storeUrl}/${data?.departmentID}`,
      }
    });
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement
  };
};
